import UsernameForm from '@/components/organism/Registration/UserForm/UserForm.container';

export const UserFormPage = () => <UsernameForm />;
